import { useLocation } from "react-router-dom";
import styled from "styled-components"
import theme from '../../../styles/theme';
import React, { useEffect, useState } from 'react';
import { navigatorPath } from './constants';
import NaviText from "./NaviText";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { useQuery, useQueryClient } from 'react-query';
import { useNavigate } from "react-router-dom";
import { Avatar, ClickAwayListener, Fade, Popper } from "@mui/material";
import { useGetCodeList } from "../../../interface/common";

const MenuHeader = styled.div`
    position: sticky;
    top:0px;
    z-index:100;
    width: 100%;
    padding: 0px 2%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${theme.color.black[10]};// #D5CECF;//
    background: ${theme.color.white[100]};
`;

const PopCard = styled.div`
    background: ${theme.color.white[100]};
    border: 1px solid ${theme.color.black[10]};
    border-radius: 8px;
    margin-top: 4px;
    padding: 8px 16px;
    text-align: center;
    > span {
        display: block;
    }
    > a {
        cursor: pointer;
    }
`;

const Navigator = ({open, setOpen, naviInfo}) => {

    const location = useLocation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { data : suser } = useQuery('ADMIN_USER_INFO');
    const {data : userDeptList} = useGetCodeList('user_dept');
    const {data : userTpList} = useGetCodeList('user_tp');

    const [targetPathInfo, setTargetPathInfo] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const [uOpen, setUOpen] = useState(false);
    const [user, setUser] = useState(false);

    useEffect(()=>{
        const fullPath  = location.pathname.split('/');
        setTargetPathInfo(navigatorPath[fullPath[fullPath.length - (isNaN(fullPath[fullPath.length - 1])? 1:2)]]);
    },[location])

    useEffect(()=>{

        if(suser && userDeptList && userTpList){
            // console.log(suser,userDeptList,userTpList)
            const dept = userDeptList.filter((item)=>item.code === suser.dept_cd)[0]
            const userTp = userTpList.filter((item)=>item.code === suser.user_tp)[0]
            const temp = {
                ...suser,
                deptNm : dept ? dept.value : '',
                userTpNm : userTp ? userTp.value : '',
            }
            setUser(temp);
        }

    },[suser, userDeptList, userTpList])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setUOpen(!uOpen);
    };

    const handleLogout = () => {
        localStorage.removeItem('ADMIN_USER_INFO');
        queryClient.resetQueries('ADMIN_USER_INFO', { exact: true });
        navigate('/admin');
    }

    return (
        <React.Fragment>
        <MenuHeader>
            <MenuOpenIcon onClick={()=>setOpen(!open)} style={{cursor:'pointer'}}/> &nbsp;
            <div style={{flexGrow:1}}><NaviText target={naviInfo}/></div>
            <ClickAwayListener onClickAway={()=>setUOpen(false)}>
                <div style={{display:'flex',alignItems:'center',cursor:'pointer'}}>
                    <Avatar onClick={handleClick}>{user && user.user_nm.substr(-2)}</Avatar>
                </div>
            </ClickAwayListener>
        </MenuHeader>
        <Popper open={uOpen} anchorEl={anchorEl} placement='bottom-end' transition sx={{zIndex:101}}>
            {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
                <PopCard onClick={()=>setUOpen(false)}>
                    <div>
                        <span style={{fontSize:'0.7rem'}}>{user.deptNm}</span>&nbsp;
                        <span>{user.user_nm}</span>
                    </div>
                    <span>{user.user_no}</span>
                    <span>{user.userTpNm}</span>
                    <span style={{cursor:'pointer'}} onClick={()=>navigate('/admin/setting/password')}>비밀번호 변경</span>
                    <div style={{width:'100%', paddingTop:'8px', textAlign:'center', cursor:'pointer'}} onClick={handleLogout}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2.75H18.12C18.9125 2.71467 19.6868 2.9947 20.2734 3.52881C20.86 4.06293 21.2111 4.80763 21.25 5.6V18.4C21.2111 19.1924 20.86 19.9371 20.2734 20.4712C19.6868 21.0053 18.9125 21.2853 18.12 21.25H12" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M15 12H2.78" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2.75 12L6.75 16" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2.75 12L6.75 8" stroke={theme.color.black[40]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </PopCard>
            </Fade>
            )}
        </Popper>
        </React.Fragment>
    )
}

export default Navigator;